export default {
  baseURL: "https://api-artefact.swynfel.eu"
}
